import { ReactNode } from 'react'

import Icon from '../Icon/Icon'
import { T } from '../Text/Text'
import Tooltip from '../Tooltip/Tooltip'
import { getEffectiveTooltipTrigger } from '../Tooltip/tooltip-interaction'

type Props = {
  content: ReactNode
  trigger?: 'click' | 'hover'
}
const QuickTip = ({ content, trigger = 'hover' }: Props) => {
  const isClickTrigger = getEffectiveTooltipTrigger(trigger) === 'click'

  if (!content) {
    return null
  }

  return (
    <Tooltip content={content} trigger={trigger}>
      <T.Label
        className={`w-fit px-0.5 ${
          isClickTrigger
            ? 'hover:text-link focus:text-link cursor-pointer rounded-xs outline-offset-[-1px] focus-visible:outline'
            : ''
        }`}
        tabIndex={isClickTrigger ? 0 : undefined}
        role={isClickTrigger ? 'button' : undefined}
      >
        <Icon.FaQuestionCircle />
      </T.Label>
    </Tooltip>
  )
}

export default React.memo(QuickTip)
